module.exports = __webpack_public_path__ + "static/media/Rosetta_decision_making.dbbe0f3b.csv";